import React, { useContext, useEffect, useState } from 'react'
import { Context } from "../components/contexts/AppContext";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
 
import {
  faCloudArrowDown,
  faXmark,
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faPlay,
  faPause,
  faRotateRight,
  faExpand,
  faCamera,
    faHeart,
  faArrowUp,
   faGlobe
} from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faYoutube,
    faFacebook,
  faWhatsapp
} from "@fortawesome/free-brands-svg-icons";
function Logo() {
      const { value } = useContext(Context);
    const [appState, setAppState] = value;
    const [showCompanyPopup, setShowCompanyPopup] = useState(false);
    const [showScrollTop, setShowScrollTop] = useState(false);


    useEffect(() => {
  const handleScroll = () => {
    setShowScrollTop(window.scrollY > 300);
  };

  window.addEventListener("scroll", handleScroll);

  return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    
    const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
    
       // ✅ FIX SOCIAL URLS
  const formatUrl = (url) => {
    if (!url) return "#";

    return url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  };
    return (
      <>
       <div className="flex items-center justify-center">
                   <div
                onClick={() => setShowCompanyPopup(true)}
                className="w-20  h-20 md:w-[70px] md:h-[70px] rounded-full    bg-white overflow-hidden cursor-pointer border border-gray-200 hover:scale-105 transition-all duration-200 shadow-sm"
              >
                <img
                  src={
                    appState?.adminDetails?.companyLogoUrl
                      ? `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState?.adminDetails?.companyLogoUrl}?width=960&height=960&optimize=photo`
                      : "/img/logo-default.png"
                  }
                  alt={appState?.adminDetails?.companyName}
                  className="w-full h-full object-contain"
              />
             
            </div> 
            </div>
{showScrollTop && (
  <button
    onClick={scrollToTop}
    className="fixed  bottom-6 right-20 z-[999] w-10 h-10 md:w-14 md:h-14 rounded-full bg-[#96303b] hover:bg-[#7d2530] text-white shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110"
  >
    <FontAwesomeIcon icon={faArrowUp} className="text-xl" />
  </button>
)}
           {/* Floating WhatsApp Button */}
{appState?.adminDetails?.phone && (
  <a
    href={`https://wa.me/91${appState.adminDetails.phone}?text=${encodeURIComponent(
      `Hi ${appState.adminDetails.companyName}, I visited your gallery and would like to know more about your services.`
    )}`}
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-[1] bg-green-500 hover:bg-green-600 w-10 h-10 md:w-14 md:h-14 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 "
  >
    <FontAwesomeIcon
      icon={faWhatsapp}
      className="text-white text-4xl"
    />
  </a>
)}
       {/* COMPANY SOCIAL POPUP */}
            {showCompanyPopup && (
              <div
                className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[999999] px-4"
                onClick={() => setShowCompanyPopup(false)}
              >
      
                <div
                  className="bg-[#96303b] rounded-[30px] p-6 w-full max-w-md shadow-2xl animate-fadeIn"
                  onClick={(e) => e.stopPropagation()}
                >
      
                  {/* TOP SECTION */}
                  <div className="flex flex-col items-center">
      
                    <div className="w-28 h-28 rounded-full overflow-hidden bg-gray-100 mb-4 shadow-lg border-4 border-white">
                      <img
                        src={
                          appState?.adminDetails?.companyLogoUrl1
                            ? `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState?.adminDetails?.companyLogoUrl}?width=960&height=960&optimize=photo`
                            : "/img/logo-default.png"
                        }
                        alt="logo"
                        className="w-full h-full object-contain"
                      />
                    </div>
      
                    <h2 className="text-2xl font-bold text-white text-center">
                      {appState?.adminDetails?.companyName}
              </h2>
              
              <div className="mt-3 text-center">
<a
  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(appState?.adminDetails?.address || "")}`}
  target="_blank"
  rel="noreferrer"
  className="inline-flex items-center gap-2 bg-white text-red-600 px-4 py-2 rounded-full font-semibold hover:scale-105 transition"
>
 
    📍 View on Google Maps
                </a>
                
              </div>
              <div className="text-white mt-3 p-3">
                <a
  href={`tel:appState?.adminDetails?.phone`}
  className="text-white"
>
  📞 {appState?.adminDetails?.phone}
</a>
              </div>
       <p className="text-lg text-white mt-2 text-center">
                     {appState?.adminDetails?.address}
                    </p>
                    <p className="text-sm text-white mt-2 text-center">
                      Connect with us on social platforms
                    </p>
      
                  </div>
      
                  {/* SOCIAL LINKS */}
               <div className="flex items-center justify-center gap-4 mt-8 flex-wrap">
      
        {/* INSTAGRAM */}
        {appState?.adminDetails?.socialLinks?.instagram && (
          <a
            href={formatUrl(appState?.adminDetails?.socialLinks?.instagram)}
            target="_blank"
            rel="noreferrer"
            className="group"
          >
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl">
      
              <FontAwesomeIcon
                icon={faInstagram}
                className="text-white text-3xl"
              />
      
            </div>
          </a>
        )}
      
        {/* YOUTUBE */}
        {appState?.adminDetails?.socialLinks?.youtube && (
          <a
            href={formatUrl(appState?.adminDetails?.socialLinks?.youtube)}
            target="_blank"
            rel="noreferrer"
            className="group"
          >
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-500 shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl">
      
              <FontAwesomeIcon
                icon={faYoutube}
                className="text-white text-3xl"
              />
      
            </div>
          </a>
        )}
      
        {/* FACEBOOK */}
        {appState?.adminDetails?.socialLinks?.facebook && (
          <a
            href={formatUrl(appState?.adminDetails?.socialLinks?.facebook)}
            target="_blank"
            rel="noreferrer"
            className="group"
          >
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-blue-600 shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl">
      
              <FontAwesomeIcon
                icon={faFacebook}
                className="text-white text-3xl"
              />
      
            </div>
          </a>
        )}
      
        {/* WEBSITE */}
        {appState?.adminDetails?.website && (
          <a
            href={formatUrl(appState?.adminDetails?.website)}
            target="_blank"
            rel="noreferrer"
            className="group"
          >
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-800 shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl">
      
              <FontAwesomeIcon
                icon={faGlobe}
                className="text-white text-3xl"
              />
      
            </div>
          </a>
        )}
      
      </div>
      
                  {/* CLOSE BUTTON */}
                  <button
                    onClick={() => setShowCompanyPopup(false)}
                    className="group relative mt-8 w-full overflow-hidden rounded-3xl bg-black py-4 font-semibold text-white transition-all duration-300 hover:scale-[1.02]"
                  >
                    <span className="relative z-10 flex items-center justify-center gap-2 text-base">
                      ✕ Close
                    </span>
      
                    <div className="absolute inset-0 bg-gradient-to-r from-gray-800 to-black opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
                  </button>
      
                </div>
              </div>
      )}
      
            </>
  )
}

export default Logo